import { css } from 'lit';
export const menuStyles = css `
    .hlx-menu-popup {
        display: flex;
        width: 100%;
        flex-direction: column;
        padding: var(--hlx-spacing-xs) 0;
        border-radius: var(--hlx-radius-xs);
        border: 1px solid var(--hlx-border-color-weak-1);
        box-shadow: var(--hlx-drop-shadow-30);
        background: var(--hlx-background-color-default);
        overflow-y: auto;
    }

    .hlx-menu-with-dividers {
        padding: 0;
    }

    .hlx-menu-dialog {
        display: block;
        z-index: 1070;
        padding: 0;
        border: none;
        position: absolute;
        margin: 0;
        transition: opacity var(--hlx-motion-duration-slow-1) var(--hlx-motion-easing-in-out)
            var(--hlx-motion-delay-default);
    }

    .hlx-menu-dialog[open] {
        visibility: visible;
        transition:
            opacity var(--hlx-motion-duration-slow-1) var(--hlx-motion-easing-in-out)
                var(--hlx-motion-delay-default),
            visibility 0ms 0ms;
        opacity: 1;
    }
    .hlx-menu-dialog:not([open]) {
        visibility: hidden;
        transition:
            opacity var(--hlx-motion-duration-slow-1) var(--hlx-motion-easing-in-out)
                var(--hlx-motion-delay-default),
            visibility 0ms calc(var(--hlx-motion-duration-slow-1) + var(--hlx-motion-delay-default));
        opacity: 0;
    }
`;
export const menuItemStyles = css `
    :host {
        --hlx-menu-item-border-width: 2px;
        --hlx-menu-item-padding-vertical: calc(
            var(--hlx-spacing-md) - var(--hlx-menu-item-border-width)
        );
        --hlx-menu-item-padding-horizontal: calc(
            var(--hlx-spacing-lg) - var(--hlx-menu-item-border-width)
        );
    }

    .hlx-menu-item {
        width: 100%;
        border: var(--hlx-menu-item-border-width) solid transparent;
        background: none;
        padding: var(--hlx-menu-item-padding-vertical) var(--hlx-menu-item-padding-horizontal);
        cursor: pointer;
        color: var(--hlx-text-color-weak-2);
        text-align: start;
        font-family: var(--hlx-text-font-family-sans-serif);
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: var(--hlx-spacing-xs);
        text-decoration: none;
    }

    .hlx-menu-item:hover:not(:disabled) {
        color: var(--hlx-text-link-color-default);
    }

    .hlx-menu-item:disabled {
        cursor: not-allowed;
        color: var(--hlx-text-color-disabled);
    }

    .hlx-menu-item:focus {
        outline: none;
    }

    .hlx-menu-item:focus-visible {
        border-color: var(--hlx-color-brand-default);
    }

    .hlx-menu-item-delete {
        color: var(--hlx-color-error-default);
    }

    .hlx-menu-item-divider {
        border-bottom: 1px solid var(--hlx-border-color-weak-1);
    }

    .hlx-menu-item-medium {
        font-size: var(--hlx-text-font-size-md);
        font-weight: var(--hlx-text-font-weight-normal);
    }

    .hlx-menu-item-small {
        font-size: var(--hlx-text-font-size-sm);
        font-weight: var(--hlx-text-font-weight-semibold);
    }

    .hlx-menu-item-small:disabled {
        font-weight: var(--hlx-text-font-weight-medium);
    }

    .hlx-menu-item-selected-icon-container {
        color: var(--hlx-color-success-default);
        margin-left: auto;
        width: var(--hlx-spacing-md);
        height: var(--hlx-spacing-md);
    }
`;
export const menuGroupStyles = css `
    .hlx-menu-group {
        display: flex;
        width: 100%;
        flex-direction: column;
        padding: var(--hlx-spacing-xs) 0 var(--hlx-spacing-xs) var(--hlx-spacing-lg);
    }

    .hlx-menu-group-with-item-dividers {
        padding: 0;
    }
    .hlx-menu-group-no-labels {
        padding-left: 0;
        padding-right: 0;
    }
    .hlx-menu-group-divider {
        border-bottom-style: solid;
        border-bottom-color: var(--hlx-border-color-weak-1);
        border-bottom-width: 1px;
    }

    .hlx-menu-group-divider.hlx-menu-group-with-item-dividers {
        border-bottom-width: 2px;
    }

    .hlx-menu-group-label {
        display: block;
        color: var(--hlx-text-color-weak-2);
        font-size: var(--hlx-text-font-size-sm);
        font-weight: var(--hlx-text-font-weight-semibold);
        font-family: var(--hlx-text-font-family-sans-serif);
        padding-right: var(--hlx-spacing-lg);
    }

    .hlx-menu-group-label-filled {
        padding-top: var(--hlx-spacing-md);
        padding-bottom: var(--hlx-spacing-2xs);
    }

    .hlx-menu-group-with-item-dividers .hlx-menu-group-label {
        display: none;
    }
`;
//# sourceMappingURL=menu.styles.js.map